// Auto-generated cornerstone translation for bg.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:23:17.052247+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Приложение за управление на коне: най-добрият избор за 2026 | EquiSight",
      description: "Сравнете приложения за управление на коне за собственик, конюшня и развъдник. Открийте защо EquiSight е пълното приложение за вашия кон.",
      keywords: [
        "приложение за управление на коне",
        "приложение за управление на конюшня",
        "дневник за коне приложение",
        "приложение за управление на няколко коня",
        "приложение за бременност на кобила",
        "приложение за развъдник на коне",
        "най-добро приложение за управление на коне",
      ],
    },
    hero: {
      eyebrow: "Помощ при избор · софтуер за управление на коне",
      breadcrumbLabel: "Приложение за управление на коне",
      title: "Приложение за управление на коне: пълното ръководство за избор за собственици, конюшни и развъдници.",
      intro: "Не просто списък с функции — честно сравнение, помощ при избор и поглед към това, което едно приложение за управление на коне наистина трябва да може през 2026 г. За един кон, за цяла конюшня или за вашия развъдник.",
      pills: [
        {
          icon: "Users",
          label: "За собственици",
        },
        {
          icon: "Building2",
          label: "За конюшни",
        },
        {
          icon: "Baby",
          label: "За развъдници",
        },
        {
          icon: "Share2",
          label: "За екипи",
        },
      ],
      ctas: [
        {
          label: "Започнете безплатно с 1 кон",
          href: "#start",
          primary: true,
        },
        {
          label: "Към таблицата за сравнение",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Защо приложението за управление на коне става все по-важно.",
      lead: "Управлението на коне на практика е разпръснато: WhatsApp, календар, Excel, снимки на телефона, хартиен паспорт, отделни фактури и устни договорки. При един кон вече е неудобно. При няколко коня, развъдници или споделена грижа се появяват пропуски, пропуснати срещи и спорове.",
      items: [
        "Кога беше тази ваксинация?",
        "Кой е платил на ковача?",
        "Коя кобила трябва да бъде проверена днес?",
        "Прочел ли е треньорът инструкцията от миналата седмица?",
        "Наистина ли съм запазил(а) този снимков документ?",
        "Актуална ли е схемата за хранене, окачена в конюшнята?",
      ],
    },
    what: {
      title: "Какво е приложение за управление на коне?",
      lead: "Приложението за управление на коне е по същество цифрово досие за всеки кон. Не разпръснати бележки, а едно място за здраве, обучение, хранене, документи, планиране, напомняния, разходи, снимки, видеоклипове и споделен достъп. Всички около коня гледат една и съща, актуална информация.",
      targetGroupsTitle: "За кого е предназначено приложението за управление на коне?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Частен собственик",
          body: "Един кон, едно досие — здраве, планиране и история в джоба ви.",
        },
        {
          icon: "Users",
          title: "Собственик на няколко коня",
          body: "Отделни профили, отделно планиране, споделен списък със задачи за целия екип.",
        },
        {
          icon: "Building2",
          title: "Пансион и манеж",
          body: "Достъп за собственика, инструкции за грижа, споделен календар и задачи.",
        },
        {
          icon: "Baby",
          title: "Развъдник",
          body: "Цикъл на кобилата, бременност, данни за жребеца, родословие и развитие на жребчето.",
        },
        {
          icon: "Target",
          title: "Треньори",
          body: "Преглед за всеки кон, записване на сесии, поставяне на цели, анализ на видеоклипове.",
        },
        {
          icon: "ClipboardList",
          title: "Специалисти",
          body: "Ковач, зъболекар, физиотерапевт или ветеринар — работят от едно и също досие.",
        },
      ],
    },
    criteria: {
      title: "Какво трябва да отговаря едно добро приложение за управление на коне?",
      lead: "Едно приложение не е само красиво — то трябва да работи практично всеки ден. Пет елемента, които не бива да липсват при избора за 2026 г.",
      items: [
        {
          icon: "FileText",
          title: "Досие за всеки кон",
          body: "Данни, възраст, порода, информация за паспорта, собственик, конюшня, снимки и документи — всичко свързано с един профил на кон.",
        },
        {
          icon: "Heart",
          title: "Здраве и грижа",
          body: "Ваксинации, обезпаразитяване, ковач, зъболекар, ветеринар, лечения, медикаменти и автоматични напомняния преди изтичане на срока.",
        },
        {
          icon: "Activity",
          title: "Обучение и напредък",
          body: "Записване на тренировки, бележки, видеоклипове, резултати от състезания, цели и напредък по дисциплина или по кон.",
        },
        {
          icon: "Apple",
          title: "Хранене и управление",
          body: "Схеми за хранене, добавки, груб фураж, тегло, телесно състояние и ежедневната рутина, която конюшнята трябва да знае.",
        },
        {
          icon: "Share2",
          title: "Споделяне с други",
          body: "Достъп за собственик, грижач, треньор, управител на конюшня или специалист — с управление на права, съответстващо на ролята на всеки.",
        },
        {
          icon: "Calendar",
          title: "Планиране и напомняния",
          body: "Споделен календар със задачи, автоматични напомняния и потвърждения, така че нищо да не се изплъзне.",
        },
      ],
    },
    comparison: {
      title: "EquiSight срещу други приложения за управление на коне.",
      lead: "Нидерландската SERP в момента е запълнена от Stalmanager, LogMyHorse, EquineM и Happie Horse. Всяко от тях има своите силни страни. Поставяме най-търсените функции едно до друго — честно и въз основа на публично достъпна информация.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Безплатен старт",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Няколко коня",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Здравно досие",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Обучение и напредък",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Хранене и добавки",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Планиране и напомняния",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Документи за всеки кон",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Споделяне с екип и права",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Модул за развъдник (пълен)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Цикъл на кобилата",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Планиране на бременност + ехографии",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Развитие на жребчето",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Интеграция на специалисти",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach анализи",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Подходящо за собственик",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Подходящо за развъдник",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Подходящо за конюшня/манеж",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Сравнението е въз основа на публично достъпни функции към януари 2026 г. Конкурентите също са добри инструменти; EquiSight е изграден, за да обедини всички модули в едно приложение.",
    },
    why: {
      title: "Защо EquiSight е различен.",
      lead: "Един дневник просто регистрира. EquiSight обединява управлението на коне, обучение, хранене, здраве, състезания, специалисти и развъдник в едно модерно приложение — и отива крачка по-напред с анализи.",
      points: [
        {
          icon: "Heart",
          title: "Едно приложение за целия живот на коня",
          body: "От жребче до спортен кон, кобила-майка или кон на пенсия. Досието расте заедно с вашия кон — нищо не изчезва по пътя.",
        },
        {
          icon: "Sparkles",
          title: "Не само данни, но и модели",
          body: "EquiCoach обединява развитие, повтарящи се оплаквания, обучение и хранене — така че навреме да забележите сигналите, а не само отделни известия.",
        },
        {
          icon: "Share2",
          title: "Изграден за сътрудничество",
          body: "Собственик, управител на конюшня, треньор, ковач и други специалисти работят от едно и също досие на коня — с права, съответстващи на тяхната роля.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Ниша · развъдник",
      title: "Управление на коне за развъдници.",
      lead: "Много конкуренти споменават развъдника в един ред. EquiSight изгради пълен модул за развъдник — защото развъдчикът рядко е крайният потребител на общо приложение, но планирането му е по-необходимо от всеки друг.",
      items: [
        "Ежедневно проследяване на цикъла на кобилата",
        "Дата на осеменяване + данни за жребеца",
        "Контрол на бременността с ехографии",
        "Очаквана дата на жребчето + предупреждения",
        "Развитие на жребчето по месеци",
        "Родословие и произход",
        "Бележки за всяка кобила",
        "Преглед на всички бременни кобили",
      ],
      ctaLabel: "Вижте модула за развъдник",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Ниша · конюшня и манеж",
      title: "Управление на коне за няколко коня и пансионни конюшни.",
      lead: "При няколко коня акцентът е по-малко върху данните и повече върху комуникацията. Всеки собственик има свои желания, рутини, договорки за хранене и медицински специфики. Всеки служител трябва да има достъп до тях без излишно търсене.",
      cards: [
        {
          t: "Коне по собственик",
          d: "Всеки собственик вижда само своя(те) кон(е).",
        },
        {
          t: "Инструкции за грижа",
          d: "Видими за конюшнята за всеки кон.",
        },
        {
          t: "Споделен календар",
          d: "Ковач, ветеринар и състезания в един изглед.",
        },
        {
          t: "Списък със задачи",
          d: "Разпределяне на служители с потвърждение.",
        },
        {
          t: "Достъп на собственика",
          d: "Клиентите виждат коня си в собственото си приложение.",
        },
        {
          t: "Спешни контакти",
          d: "Винаги намираеми при стрес в конюшнята.",
        },
      ],
      ctaLabel: "Вижте модула за манеж",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "От WhatsApp, Excel и бяла дъска към EquiSight.",
      lead: "Конкретно: ето как се променя ежедневното ви управление на коне.",
      rows: [
        {
          before: "WhatsApp групи",
          after: "Структурирани бележки за всеки кон",
        },
        {
          before: "Excel таблици",
          after: "Живо досие на коня с история",
        },
        {
          before: "Бяла дъска в конюшнята",
          after: "Споделено планиране на вашия телефон",
        },
        {
          before: "Отделни снимки в камерата",
          after: "Медия, свързана с вашия кон",
        },
        {
          before: "Устни договорки",
          after: "Задачи и напомняния с потвърждение",
        },
        {
          before: "Изгубен хартиен паспорт",
          after: "Документи винаги под ръка",
        },
      ],
    },
    helper: {
      title: "Кое приложение за управление на коне е подходящо за вас?",
      lead: "Отговорете на тези 5 въпроса и ще получите честна препоръка — дори когато тя невинаги е EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Имате ли един кон или няколко коня?",
          options: [
            {
              label: "Един кон",
              score: 1,
            },
            {
              label: "2–5 коня",
              score: 2,
            },
            {
              label: "Повече от 5 коня",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Управлявате ли коне на клиенти или трети лица?",
          options: [
            {
              label: "Не, само моите собствени коне",
              score: 0,
            },
            {
              label: "Понякога — за семейство или познати",
              score: 1,
            },
            {
              label: "Да, професионално (конюшня / манеж)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Искате ли да проследявате развъдника и бременността?",
          options: [
            {
              label: "Не е приложимо",
              score: 0,
            },
            {
              label: "Понякога — случайно развъждане",
              score: 1,
            },
            {
              label: "Да, аз съм (или ще стана) развъдчик",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Работите ли заедно с треньор, грижач или специалист?",
          options: [
            {
              label: "Не, правя всичко сам(а)",
              score: 0,
            },
            {
              label: "Да, с 1 човек",
              score: 1,
            },
            {
              label: "Да, с няколко човека",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Искате ли само да регистрирате или и да получавате анализи?",
          options: [
            {
              label: "Само регистриране",
              score: 1,
            },
            {
              label: "Регистриране + планиране",
              score: 2,
            },
            {
              label: "Регистриране + планиране + анализи",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Прост дневник е достатъчен — и расте заедно с вас.",
          body: "За един кон без споделена грижа всяко приложение за управление на коне е подходящо. EquiSight стартира безплатно с 1 кон, така че нямате никакъв риск. Ако по-късно искате да добавите повече коне, треньор или развъдник, всичко вече е включено.",
          cta: "Започнете безплатно с 1 кон",
        },
        mid: {
          title: "EquiSight е подходящ за вашата ситуация.",
          body: "Имате множество нужди (няколко коня, сътрудничество или анализи). Повечето конкуренти покриват 1–2 модула; EquiSight ги обединява в едно приложение, без да се налага да свързвате отделни инструменти.",
          cta: "Вижте какво може EquiSight",
        },
        high: {
          title: "EquiSight е най-логичният избор.",
          body: "Вашата ситуация съчетава няколко коня, сътрудничество, развъдник и/или анализи. Именно тук EquiSight прави разликата — без разпръснати инструменти, а едно досие на коня за всичко и всички около него.",
          cta: "Започнете безплатно с EquiSight",
        },
      },
    },
    faqTitle: "Често задавани въпроси за приложения за управление на коне",
    faq: [
      {
        q: "Кое е най-доброто приложение за управление на коне?",
        a: "Най-доброто приложение за управление на коне зависи от вашата ситуация. За прост дневник са подходящи много приложения. Ако искате да комбинирате здраве, обучение, хранене, документи, развъдник, планиране и сътрудничество, EquiSight е изграден като пълно решение, където всичко се събира в едно досие.",
      },
      {
        q: "Мога ли да управлявам няколко коня в едно приложение?",
        a: "Да. Едно добро приложение за управление на коне трябва да поддържа няколко коня, включително собственици, грижачи, рутини, документи, срещи и напомняния за всеки кон. EquiSight е проектиран за това от първия ред код — конете са отделни досиета, а не редове в списък.",
      },
      {
        q: "Подходящ ли е EquiSight и за развъдници?",
        a: "Да. EquiSight може да бъде настроен с функции за развъдник като цикъл на кобилата, дата на осеменяване, контрол на бременността, данни за жребеца, родословие, очаквана дата на жребчето и развитие на жребчето. Именно в тази област повечето конкурентни приложения почти не предлагат функционалност.",
      },
      {
        q: "Мога ли да споделям данни с моя треньор или ковач?",
        a: "Да. Целта на EquiSight е релевантната информация да може да се споделя сигурно с хората около коня — треньор, ковач, зъболекар, ветеринар, физиотерапевт, грижач или собственик. Всеки човек получава само правата, необходими за неговата роля.",
      },
      {
        q: "Защо да не използвате просто WhatsApp или Excel?",
        a: "WhatsApp и Excel работят, докато всичко е просто. Веднага щом имате няколко коня, срещи, документи, лечения, собственици или данни за развъдника, те стават податливи на грешки: информацията се разпръсква, търсенето отнема време и устните договорки изчезват. Едно приложение за управление на коне събира всичко на едно място за всеки кон с автоматични напомняния.",
      },
      {
        q: "Колко струва EquiSight?",
        a: "Можете да започнете безплатно с 1 кон. Ако искате да управлявате няколко коня, да активирате развъдника или да дадете достъп на специалисти, съществуват достъпни Premium планове. Вижте актуалните опции на страницата с цени.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Софтуер за манеж: пълно сравнение и помощ при избор 2026",
      description: "Сравнете софтуер за манеж за уроци, ездачи, коне и администрация. Открийте кое приложение е подходящо за вашия манеж или пансионна конюшня.",
      keywords: [
        "софтуер за манеж",
        "приложение за управление на конюшня",
        "административен софтуер за манеж",
        "планиране на уроци манеж",
        "софтуер за пансионна конюшня",
        "администрация на ездачи",
        "администрация на коне манеж",
      ],
    },
    hero: {
      eyebrow: "Помощ при избор · софтуер за манеж",
      breadcrumbLabel: "Софтуер за манеж",
      title: "Софтуер за манеж: пълното ръководство за избор за манежи и пансионни конюшни.",
      intro: "Планиране на уроци, администрация на ездачи, управление на коне, фактуриране и комуникация — добрият софтуер за манеж обединява всичко. Сравнете най-известните опции и открийте коя пасва на вашата конюшня или манеж.",
      pills: [
        {
          icon: "Calendar",
          label: "Планиране на уроци",
        },
        {
          icon: "Users",
          label: "Ездачи и клиенти",
        },
        {
          icon: "Heart",
          label: "Грижа за конете",
        },
        {
          icon: "CreditCard",
          label: "Фактуриране",
        },
      ],
      ctas: [
        {
          label: "Заявете демо",
          href: "#start",
          primary: true,
        },
        {
          label: "Към таблицата за сравнение",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Защо разпръснатите инструменти забавят манежа.",
      lead: "Повечето манежи работят с пачуърк от инструменти: планиране на уроци на бяла дъска, регистрация на ездачи в Excel, фактуриране в отделен инструмент, грижа за конете в WhatsApp и контакт със собствениците чрез лични съобщения. При натоварена седмица се появяват двойни резервации, забравени фактури или коне, за които не е ясно кой ездач ги получава.",
      items: [
        "Кой е на урок при Жасмин в момента?",
        "Кой ездач все още не е платил за март?",
        "Кой кон не трябва да се използва тази седмица?",
        "Кои са контактите за спешни случаи на учениците?",
        "Получи ли собственикът на Стардъст фактурата от ковача?",
        "Кой кон е в кой бокс?",
      ],
    },
    what: {
      title: "Какво е софтуер за манеж?",
      lead: "Софтуерът за манеж обединява планирането на уроци, администрацията на ездачи, управлението на коне, фактурирането и комуникацията в един инструмент. Без акробатика с Excel или спагети от WhatsApp — само едно място, откъдето манежът работи и собствениците/ездачите следят всичко.",
      targetGroupsTitle: "За какъв тип бизнес е предназначен софтуерът за манеж?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Малък манеж (1-15 коня)",
          body: "Основно планиране на уроци и плащания — администрация без главоболие.",
        },
        {
          icon: "Users",
          title: "Среден манеж (15-40 коня)",
          body: "Няколко инструктора, планиране на уроци + разписание на конете + администрация на ездачи.",
        },
        {
          icon: "ClipboardList",
          title: "Голяма езда и пансионна конюшня (40+)",
          body: "Пълна операция, включително фактуриране, планиране на хранене и ковач.",
        },
        {
          icon: "Heart",
          title: "Пансионна конюшня",
          body: "Портал за собственици, индивидуални инструкции за грижа, споделен календар.",
        },
        {
          icon: "Target",
          title: "Тренировъчна конюшня за скачане",
          body: "Планиране на състезания, тренировки за всеки кон, контакт с клиенти.",
        },
        {
          icon: "FileText",
          title: "Хипически предприемачи",
          body: "Комбинация от уроци + пансион + клиника + търговия — всичко от една система.",
        },
      ],
    },
    criteria: {
      title: "Какво трябва да предлага добрият софтуер за манеж?",
      lead: "Красивото приложение не означава нищо, ако служителите ви не искат да го използват. Пет практични критерия, които правят разликата между успех и разочарование.",
      items: [
        {
          icon: "Calendar",
          title: "Планиране на уроци на няколко нива",
          body: "Начинаещи/напреднали, дресаж/скачане, свързвания кон-ездач и календари на инструктори — всичко видимо наведнъж.",
        },
        {
          icon: "Users",
          title: "Администрация на ездачи",
          body: "Профили, ниво, абонамент, карта за уроци и връзки с членове на семейството за младежки ездачи.",
        },
        {
          icon: "Heart",
          title: "Разписание на конете",
          body: "Колко често се използва всеки кон, с периоди на почивка, наранявания и лечение.",
        },
        {
          icon: "CreditCard",
          title: "Фактуриране и абонаменти",
          body: "Месечни абонаменти, карти за уроци, единични уроци и автоматично инкасо.",
        },
        {
          icon: "Share2",
          title: "Портал за собственици (пансион)",
          body: "Собствениците виждат своя кон в собствено приложение — календар, разходи, ковач и бележки без телефонни обаждания.",
        },
        {
          icon: "Bell",
          title: "Комуникация и напомняния",
          body: "Автоматични напомняния за уроци, известия за плащания, съобщения за ковач — без изпращане на съобщения.",
        },
      ],
    },
    comparison: {
      title: "EquiSight срещу друг софтуер за манеж.",
      lead: "Много инструменти за манеж са силни в планирането на уроци или фактурирането, но рядко едновременно в грижата за конете и комуникацията със собствениците. Сравняваме ги честно.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Безплатен старт / пробен период",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Планиране на уроци",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Няколко инструктора",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Администрация на ездачи",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Разписание на конете",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Грижа за конете (ваксини/ковач)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Карта за уроци / абонамент",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Онлайн плащания",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Автоматично фактуриране",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Портал за собственици (пансион)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Интеграция с ковач/ветеринар",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Напомняния чрез WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Мобилно (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Планиране на състезания",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Подходящ за пансионна конюшня",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Сравнението е базирано на публично достъпни функции от януари 2026 г. Stalmanager е силен в администрацията, EquiSight се отличава с функционалността за пансион + грижа за конете + портал за собственици.",
    },
    why: {
      title: "Защо EquiSight е различен за манежи и пансионни конюшни.",
      lead: "EquiSight надхвърля функциите на обикновен планировчик за уроци. Ние виждаме манежа като пълна операция: коне, хора, комуникация и финанси — всички зависими един от друг.",
      points: [
        {
          icon: "Heart",
          title: "Конят в центъра, не календарът",
          body: "Всеки кон има свое досие. Участие в уроци, здраве, ковач и състезания в една времева линия — не 3 отделни инструмента.",
        },
        {
          icon: "Share2",
          title: "Собствениците следят без телефонни обаждания",
          body: "Собствениците на пансионната конюшня имат собствен изглед: разходи, планиране, снимки и бележки — спестява 5-10 обаждания на седмица.",
        },
        {
          icon: "Bell",
          title: "Автоматична комуникация",
          body: "Напомняне за урок, напомняне за ваксина, фактура — автоматично, чрез приложение/имейл/SMS. Без групови съобщения в WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "За пансионната конюшня",
      title: "Какво получава пансионната конюшня от EquiSight.",
      lead: "Пансионните конюшни имат уникални предизвикателства, които обикновеният софтуер за манеж не решава.",
      cards: [
        {
          t: "Портал за собственици",
          d: "Всеки собственик вижда само своя кон/коне, календар и разходи.",
        },
        {
          t: "Инструкции за грижа за всеки кон",
          d: "Храна, груб фураж, добавки, разписание за одеяла — видими за персонала на конюшнята.",
        },
        {
          t: "Споделен календар",
          d: "Ковач, ветеринар и посещения на собственици в един изглед.",
        },
        {
          t: "Разходи за консумативи на кон",
          d: "Постеля, фураж, концентрирана храна — разпределени по собственик.",
        },
        {
          t: "Контакти за спешни случаи за кон",
          d: "Собственик + ветеринар + ковач — винаги намираеми за персонала.",
        },
        {
          t: "Управление на ваканции",
          d: "Кои коне излизат на паша, почивка или рехабилитация?",
        },
      ],
    },
    beforeAfter: {
      title: "От бяла дъска и Excel към EquiSight.",
      lead: "Конкретно: ето как се променя работната седмица в манежа.",
      rows: [
        {
          before: "Бяла дъска с планирането на уроците",
          after: "Планиране на живо за всеки инструктор",
        },
        {
          before: "Excel с ездачи и бележки от уроци",
          after: "CRM за клиенти с история на уроците",
        },
        {
          before: "WhatsApp до собствениците",
          after: "Портал за собственици за техния кон",
        },
        {
          before: "Месечно инкасо ръчно",
          after: "Автоматично фактуриране + iDEAL",
        },
        {
          before: "Грижа за конете на табло с бележки",
          after: "Инструкции за грижа на кон, споделени",
        },
        {
          before: "Устна уговорка с ковача",
          after: "Планиране на ковач с потвърждения",
        },
      ],
    },
    helper: {
      title: "Кой софтуер за манеж е подходящ за вас?",
      lead: "5 въпроса, за да разберете дали EquiSight е правилната платформа за вашия манеж или пансионна конюшня.",
      questions: [
        {
          id: "size",
          q: "Колко коня имате в бизнеса си?",
          options: [
            {
              label: "По-малко от 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Повече от 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Каква е основната ви дейност?",
          options: [
            {
              label: "Предимно даване на уроци",
              score: 1,
            },
            {
              label: "Пансионна конюшня (коне на пансион)",
              score: 3,
            },
            {
              label: "Комбинация от уроци и пансион",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "С колко инструктора работите?",
          options: [
            {
              label: "Само аз",
              score: 1,
            },
            {
              label: "2-3 инструктора",
              score: 2,
            },
            {
              label: "4 или повече",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Как управлявате фактурирането си в момента?",
          options: [
            {
              label: "Ръчно (Word/Excel)",
              score: 3,
            },
            {
              label: "Отделна счетоводна програма",
              score: 2,
            },
            {
              label: "Интегрирано в инструмента за уроци",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Как комуникирате със собствениците?",
          options: [
            {
              label: "Лично / WhatsApp",
              score: 3,
            },
            {
              label: "Имейл + WhatsApp",
              score: 2,
            },
            {
              label: "Портал за собственици в инструмента",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Лек инструмент или Excel може да свърши работа засега — но EquiSight расте заедно с вас.",
          body: "За малък урочен бизнес с един инструктор и малко пансион един обширен пакет не е необходим веднага. EquiSight стартира безплатно и расте заедно с вашия манеж — без болка при миграция след няколко години.",
          cta: "Стартирайте безплатно",
        },
        mid: {
          title: "EquiSight е логичното надграждане за вашия манеж.",
          body: "Няколко инструктора, комбинация от уроци и пансион или фактуриране, което сега е разделено — EquiSight обединява всичко в един работен процес. Особено порталът за собственици спестява много ад хок комуникация.",
          cta: "Заявете демо",
        },
        high: {
          title: "EquiSight е създаден за вашия мащаб.",
          body: "Пансионна конюшня + уроци + няколко инструктора е точно там, където EquiSight се отличава от класическите инструменти за манеж. Порталът за собственици и интеграцията за грижа за конете спестяват часове администрация и комуникация всяка седмица.",
          cta: "Планирайте демо за вашата конюшня",
        },
      },
    },
    faqTitle: "Често задавани въпроси относно софтуера за манеж",
    faq: [
      {
        q: "Кой е най-добрият софтуер за манеж?",
        a: "За чисто планиране на уроци има няколко добри опции. Когато имате нужда от пансионна конюшня, няколко инструктора или проследяване на грижата за конете, EquiSight се превръща в пълното решение — без жонглиране с инструменти, всичко на едно място.",
      },
      {
        q: "Мога ли да импортирам съществуващи клиенти и уроци?",
        a: "Да. Данните за клиенти и разписанията на уроците могат да се импортират чрез CSV. Помагаме на активни манежи с еднократна миграция, така че да не се налага ръчно въвеждане на 200 ездача.",
      },
      {
        q: "Работи ли и за пансионна конюшня без уроци?",
        a: "Да. Режимът за пансионна конюшня изключва уроците и се фокусира върху портала за собственици, хранене/грижа, планиране на ковач и разпределяне на разходи по кон.",
      },
      {
        q: "Могат ли ездачите сами да се записват и плащат?",
        a: "Да. Ездачите могат чрез собствен акаунт да видят кои уроци са свободни, да се запишат, да платят таксата за урок с iDEAL и да купят карти за уроци.",
      },
      {
        q: "Как стои въпросът с поверителността на данните за конете и собствениците?",
        a: "Всяко лице има роля (собственик, ездач, инструктор, служител). За всяка роля се вижда само необходимото. Собствениците виждат само своя кон, ездачите — само собствените си уроци.",
      },
      {
        q: "Може ли EquiSight да се свърже с моя счетоводен софтуер?",
        a: "Да, налични са интеграции с Exact, Moneybird и e-Boekhouden. Фактурите тогава автоматично се прехвърлят към вашето счетоводство.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Приложение за треньор по конен спорт: сравнение и помощ при избор за коучове 2026",
      description: "Сравнете приложения за треньори по конен спорт: дневник за тренировки, видео, цели, анализ на протоколи и управление на клиенти. Намерете правилния инструмент за коучове.",
      keywords: [
        "приложение за треньор по конен спорт",
        "приложение за инструктор",
        "приложение за тренировка на кон",
        "приложение за коучинг на ездач",
        "дневник за тренировки с кон",
        "анализ на протокол по дресура",
        "софтуер за треньор по конен спорт",
      ],
    },
    hero: {
      eyebrow: "Помощ при избор · софтуер за треньор",
      breadcrumbLabel: "Приложение за треньор",
      title: "Приложение за треньор по конен спорт: пълно ръководство за инструктори и коучове.",
      intro: "Един треньор или инструктор жонглира с двойки, уроци, видеа, цели и състезания. Сравнете най-добрите приложения за треньори по конен спорт и изберете платформата, която ще расте заедно с вашия коучинг и през 2026 г.",
      pills: [
        {
          icon: "Target",
          label: "Цели и планиране",
        },
        {
          icon: "Video",
          label: "Видео анализ",
        },
        {
          icon: "TrendingUp",
          label: "Напредък",
        },
        {
          icon: "Users",
          label: "Клиенти/двойки",
        },
      ],
      ctas: [
        {
          label: "Започнете безплатно като треньор",
          href: "#start",
          primary: true,
        },
        {
          label: "Към таблицата за сравнение",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Защо коучингът чрез WhatsApp пречи на треньорите.",
      lead: "Повечето треньори работят с отделни инструменти: WhatsApp за комуникация, бележник за уроци, YouTube или WeTransfer за видеа и Excel за резултати от състезания. При 5 ездачи работи. При 20 ездачи информацията се губи, забравяте цели и изгубвате контрол върху индивидуалния напредък.",
      items: [
        "Каква е целта на Anouk за този сезон?",
        "Какво видео изпратих на Bram миналия месец?",
        "Видяла ли е Lara анализа на протокола от последното ѝ състезание?",
        "Коя двойка тренира колко пъти седмично?",
        "Прочел ли е собственикът на Stardust моите инструкции за тренировка?",
        "Кога за последен път дадох обратна връзка за нестабилен импулс?",
      ],
    },
    what: {
      title: "Какво представлява приложение за треньор по конен спорт?",
      lead: "Едно приложение за треньор комбинира CRM за коучинг (двойки, уроци, цели), дневник за тренировки на кон, видео обратна връзка, планиране на състезания и анализ на протоколи. Без отделен WhatsApp/YouTube/Excel — само една платформа, в която треньорът и ездачът работят заедно.",
      targetGroupsTitle: "За какъв тип треньор е предназначено?",
      targetGroups: [
        {
          icon: "Target",
          title: "Инструктор по дресура",
          body: "Сканиране на протоколи, свързване на коментари от журито с тренировъчни цели, проследяване на напредъка.",
        },
        {
          icon: "Activity",
          title: "Треньор по скокове",
          body: "Планиране на маршрути, обратна връзка след разезди, управление на височини за всеки кон.",
        },
        {
          icon: "Award",
          title: "Коуч по евентинг",
          body: "Три дисциплини, три плана — всички видими едновременно.",
        },
        {
          icon: "TrendingUp",
          title: "Коуч по спортни постижения",
          body: "EPI проследяване, състезания, цели — за топ спортисти и техните екипи.",
        },
        {
          icon: "Users",
          title: "Инструктор в конна база",
          body: "Групови уроци и индивидуален коучинг в едно приложение.",
        },
        {
          icon: "Heart",
          title: "Коуч за любители",
          body: "Конна терапия, начинаещи, собственици с един кон.",
        },
      ],
    },
    criteria: {
      title: "Какви критерии трябва да отговаря едно добро приложение за треньор?",
      lead: "Треньорството е човешка работа, но правилният инструмент ви прави 30-50% по-ефективни и помага на ездачите да се подобряват и между уроците.",
      items: [
        {
          icon: "Users",
          title: "Управление на двойки",
          body: "Кон + ездач като една единица, с ниво, цели, напредък и история.",
        },
        {
          icon: "ClipboardList",
          title: "Бележки от уроци и цели",
          body: "Бележка с акценти за всеки урок, свързана с дългосрочни цели.",
        },
        {
          icon: "Video",
          title: "Видео обратна връзка",
          body: "Качете видео, маркирайте моменти, добавете говорена или писмена обратна връзка.",
        },
        {
          icon: "Target",
          title: "Анализ на състезания и протоколи",
          body: "Сканирайте протоколи (KNHS/FEI), вижте резултати по елементи, коментари от журито и тенденции.",
        },
        {
          icon: "Calendar",
          title: "Планиране и карти за уроци",
          body: "Календар, плащания, абонаменти и автоматични напомняния.",
        },
        {
          icon: "Share2",
          title: "Комуникация с ездача",
          body: "Ездачът вижда собствената си страница с уроци, видеа, цели и обратна връзка.",
        },
      ],
    },
    comparison: {
      title: "EquiSight срещу други приложения за треньори.",
      lead: "Някои инструменти за треньори се фокусират върху замяната на WhatsApp, други върху анализа на протоколи. EquiSight комбинира и двете с истинско досие на коня — така ездачът се подобрява и между уроците.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Безплатен старт",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Управление на двойки",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Бележки от уроци и обратна връзка",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Дългосрочни цели",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Качване на видео + обратна връзка",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Сканиране на протоколи KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (индекс на постиженията)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Календар на състезанията",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Портал за ездача",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Карта за уроци / абонамент",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Онлайн плащания",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Интегрирано досие на коня",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Видима информация за ковач/ветеринар",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "За инструктор И ездач",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Много коне на един ездач",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Сравнението е направено въз основа на публично достъпни функции към януари 2026 г. EquiSight е уникален с анализ на протоколи + EPI и ги комбинира с общо управление на коне.",
    },
    why: {
      title: "Защо EquiSight предлага различно преживяване за треньора.",
      lead: "Повечето инструменти за треньори свършват там, където свършва урокът. EquiSight продължава — в досието на коня, в анализа на състезанията, в сътрудничеството с ветеринара и собственика.",
      points: [
        {
          icon: "TrendingUp",
          title: "Сканиране на протокол → тренировъчна цел",
          body: "Сканирайте протокол на KNHS и веднага вижте кои елементи се нуждаят от внимание. Целите изникват автоматично.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach усилва вашата преценка",
          body: "Данните от множество уроци, състезания и протоколи разкриват модели, които трудно се запомнят.",
        },
        {
          icon: "Share2",
          title: "Интегрирано с коня",
          body: "Треньорът вижда ваксинациите, историята на ковача и наранявания на коня — няма да планирате тренировка по време на възстановяване.",
        },
      ],
    },
    nicheA: {
      eyebrow: "За дресура и скокове",
      title: "Какво съдържа едно досие за коучинг в EquiSight.",
      lead: "За всяка двойка получавате поток за коучинг, който събира всичко на едно място — без повече изгубени неща в WhatsApp.",
      items: [
        "Бележки от уроци с акценти за всяка сесия",
        "Дългосрочни цели + етапи",
        "Качване на видео с коментари по времеви код",
        "Сканиране на протоколи KNHS/FEI с резултати",
        "Коментари от журито, свързани с тренировката",
        "Резултати от състезания и тенденция на EPI",
        "Контакт с клиента и история на уроците",
        "Карта за уроци / абонамент / фактури",
        "Графика на напредъка по дисциплина",
        "Споделен достъп със собственика на коня",
      ],
      ctaLabel: "Разгледайте модула за треньори",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "От WhatsApp + YouTube към EquiSight Trainer.",
      lead: "Конкретно: ето как се променя вашият работен процес за коучинг.",
      rows: [
        {
          before: "WhatsApp с отделни видео линкове",
          after: "Видео с обратна връзка по времеви код в досието",
        },
        {
          before: "Бележник за всеки ездач",
          after: "Дневник за коучинг с цели и история",
        },
        {
          before: "Excel с резултати от състезания",
          after: "EPI графика + анализ на протоколи",
        },
        {
          before: "Устни цели",
          after: "Етапи с индикатор за напредък",
        },
        {
          before: "Отделен инструмент за фактуриране",
          after: "Уроци + iDEAL + абонамент в приложението",
        },
        {
          before: "Имейл до собственика за напредъка",
          after: "Собственикът следи в собствен изглед",
        },
      ],
    },
    helper: {
      title: "Кое приложение за треньор е подходящо за вас?",
      lead: "5 въпроса, за да разберете дали специализиран инструмент за коучинг добавя стойност към вашата практика.",
      questions: [
        {
          id: "clients",
          q: "Колко активни двойки коучвате?",
          options: [
            {
              label: "По-малко от 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Повече от 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Каква е основната ви дисциплина?",
          options: [
            {
              label: "Дресура",
              score: 3,
            },
            {
              label: "Скокове",
              score: 2,
            },
            {
              label: "Любителска / разнообразна",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Използвате ли видео в коучинга?",
          options: [
            {
              label: "Рядко",
              score: 0,
            },
            {
              label: "Понякога (ръчно)",
              score: 2,
            },
            {
              label: "Често — системно",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Коучвате ли състезателни ездачи?",
          options: [
            {
              label: "Не, любители",
              score: 0,
            },
            {
              label: "Понякога на състезания",
              score: 2,
            },
            {
              label: "Много — стартовите карти са централни",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Искате ли да измервате своя коучинг?",
          options: [
            {
              label: "Не, интуицията е достатъчна",
              score: 0,
            },
            {
              label: "Да, но нямам време",
              score: 2,
            },
            {
              label: "Да — коучинг, базиран на данни",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Прост инструмент или дори WhatsApp са достатъчни — засега.",
          body: "За по-малко от 5 ездачи без много видео или състезания приложението за коучинг е излишно. EquiSight започва безплатно, така че можете да го изпробвате, когато практиката ви расте.",
          cta: "Започнете безплатно",
        },
        mid: {
          title: "EquiSight Trainer ви прави системно по-ефективни.",
          body: "С 5-15 двойки губите часове месечно в WhatsApp и отделни видеа. EquiSight обединява всичко, сканира протоколите автоматично и гарантира, че ездачите могат да видят обратната си връзка по всяко време.",
          cta: "Изпробвайте модула Trainer",
        },
        high: {
          title: "EquiSight е създаден за вашия мащаб на коучинг.",
          body: "Много ездачи, видео, състезания и коучинг, базиран на данни — точно тук EquiSight се отличава. EPI + сканиране на протоколи + досие на коня ви дава преднина, която конкурентите нямат.",
          cta: "Планирайте демо за вашата коучинг практика",
        },
      },
    },
    faqTitle: "Често задавани въпроси за приложения за треньори",
    faq: [
      {
        q: "Кое е най-доброто приложение за треньор по конен спорт?",
        a: "За чиста комуникация много инструменти са достатъчни (дори WhatsApp). За цели, видео анализ, сканиране на протоколи, проследяване на състезания и управление на клиенти в едно — EquiSight е най-пълното решение, особено защото следи и самия кон, не само двойката.",
      },
      {
        q: "Може ли EquiSight автоматично да чете протоколи от състезания?",
        a: "Да. Качете протокол на KNHS или FEI и EquiSight извлича резултатите по елементи, коментарите на журито и ги свързва с двойката. Тенденциите се виждат в рамките на множество състезания.",
      },
      {
        q: "Какво е EPI (Equestrian Performance Index)?",
        a: "EPI е резултат в EquiSight, който преобразува множество резултати от състезания в сравним индекс на постиженията. По този начин виждате истински напредък в различни класове и при различни журита.",
      },
      {
        q: "Могат ли ездачите сами да записват и плащат за уроци?",
        a: "Да. Ездачите влизат в системата, виждат наличните часове за уроци, купуват карти за уроци и плащат чрез iDEAL. Вие решавате какво да предложите.",
      },
      {
        q: "Работи ли и за инструктор, работещ в конна база?",
        a: "Да. Можете да работите като независим треньор с ваши собствени клиенти, без да свързвате акаунт на конна база. Клиентите ви плащат директно.",
      },
      {
        q: "Мога ли да прехвърля съществуващи видеа и бележки?",
        a: "Видеата можете да качвате по двойки или чрез инструмент за пакетно качване. Бележките се импортират чрез CSV. Помагаме на активните треньори с еднократна миграция.",
      },
    ],
  },
  ui: {
    sectionEyebrows: {
      pains: "Защо това е болезнено",
      basics: "Основи",
      criteria: "Какво го прави добро?",
      comparison: "Честно сравнение",
      why: "Разликата",
      beforeAfter: "От разпокъсаност към яснота",
      helper: "5 въпроса",
    },
    table: {
      feature: "Функция",
      today: "Днес",
      withEquisight: "С EquiSight",
    },
    helper: {
      questionLabel: "Въпрос {{current}} от {{total}}",
      answerPrompt: "Отговорете на {{count}} оставащия въпрос, за да видите препоръка.",
      answerPromptPlural: "Отговорете на {{count}} оставащи въпроса, за да видите препоръка.",
      resultEyebrow: "Вашият резултат",
    },
    targetGroupsFallback: "За кого е предназначено това?",
    faqTitleFallback: "Често задавани въпроси",
  },
  fokkerij: {
    seo: {
      title: "Fokkerij software paard: complete vergelijking 2026",
      description: "Vergelijk fokkerij software voor paarden: merriecyclus, dracht, hengstkeuze en veulens. Ontdek waarom EquiSight de complete fokkerij app is.",
      keywords: [
        "fokkerij software paard",
        "merriecyclus app",
        "merrie drachtigheid app",
        "veulen registratie app",
        "stamboek app paard",
        "dekplanning paard",
        "hengstkeuze app",
      ],
    },
    hero: {
      eyebrow: "Keuzehulp · fokkerij software",
      breadcrumbLabel: "Fokkerij software",
      title: "Fokkerij software voor paarden: de complete vergelijking voor 2026.",
      intro: "Een fokmerrie verdient meer dan een algemene paardenbeheer app. Vergelijk de fokkerij-functies van de bekendste tools, ontdek waarop je écht moet letten, en kies bewust voor de software die past bij jouw stoeterij — groot of klein.",
      pills: [
        {
          icon: "Baby",
          label: "Merrie cyclus",
        },
        {
          icon: "Heart",
          label: "Drachtcontrole",
        },
        {
          icon: "Sparkles",
          label: "Veulenontwikkeling",
        },
        {
          icon: "FileText",
          label: "Stamboek",
        },
      ],
      ctas: [
        {
          label: "Start gratis met de fokkerijmodule",
          href: "#start",
          primary: true,
        },
        {
          label: "Naar vergelijkingstabel",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Waarom een gewone paardenbeheer app niet volstaat voor fokkerij.",
      lead: "De meeste paardensport apps zijn ontworpen voor één sport- of recreatiepaard. Een fokkerij heeft een hele andere ritmiek: hengstigheid, inseminatie, drachtcontrole, echo's, veulenkalender, stamboom en verkoop. Eén Excel raakt na 2 seizoenen uit het lood — en bij meerdere merries verlies je grip.",
      items: [
        "Wanneer was die laatste cyclus van Bonita ook alweer?",
        "Welke hengst staat gepland voor de dekking volgend seizoen?",
        "Is de 21-daagse echo al ingepland?",
        "Welke veulens van 2024 zijn al verkocht?",
        "Waar staat het stamboomdiagram tot opa van moederszijde?",
        "Waar zijn de DNA-monsters en paspoortgegevens?",
      ],
    },
    what: {
      title: "Wat is fokkerij software voor paarden?",
      lead: "Fokkerij software is een gespecialiseerd dossier per merrie en hengst, gecombineerd met een fokjaar-kalender, drachtplanning, veulenregistratie en stamboomweergave. Geen algemeen paardenlogboek, maar een tool die de fokcyclus begrijpt: van eerste hengstigheid tot afspenen.",
      targetGroupsTitle: "Voor welk type fokker is fokkerij software bedoeld?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobbyfokker (1-3 merries)",
          body: "Eén of twee dekkingen per jaar — overzicht zonder Excel-acrobatiek.",
        },
        {
          icon: "Building2",
          title: "Kleine stoeterij (4-10 merries)",
          body: "Een fokjaarplan met cyclus, inseminatie, drachtcontroles en veulendossier.",
        },
        {
          icon: "Users",
          title: "Professionele stoeterij (10+)",
          body: "Meerdere medewerkers, hengstkeuze per merrie, verkoop en marketing.",
        },
        {
          icon: "Target",
          title: "Hengstenhouder",
          body: "Bestelhistorie, sperma-statistieken en agenda per hengst.",
        },
        {
          icon: "Heart",
          title: "Embryotransplantatie",
          body: "Donor + ontvangermerrie als gekoppeld dossier, ET-kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Stamboek registratie",
          body: "DNA-monsters, paspoortdocumenten en stamboomgegevens.",
        },
      ],
    },
    criteria: {
      title: "Waar moet goede fokkerij software aan voldoen?",
      lead: "Niet elke 'fokkerijfunctie' in een paardenapp is hetzelfde. Vijf kerngebieden waar fokkers veel tijd verliezen — en waar software écht verschil maakt.",
      items: [
        {
          icon: "Calendar",
          title: "Merriecyclus & hengstigheid",
          body: "Dagelijkse log, voorspellende ovulatie, voortrolling per cyclus en automatische herinneringen.",
        },
        {
          icon: "Heart",
          title: "Inseminatie & drachtcontrole",
          body: "Dek- en inseminatiedata, hengstgegevens, 14-daagse echo, 21-daagse echo, 60-daagse echo en geslachtsbepaling.",
        },
        {
          icon: "Baby",
          title: "Veulenontwikkeling",
          body: "Geboorte gegevens, gewichtsgrafiek, ontwormingsschema, speenmoment, paspoortregistratie.",
        },
        {
          icon: "FileText",
          title: "Stamboom & papieren",
          body: "Stamboomweergave tot 4-5 generaties, DNA, paspoortnummers en stamboekstatus.",
        },
        {
          icon: "Target",
          title: "Hengstkeuze & matching",
          body: "Filtreren op discipline, lijnen, hengstgegevens en historisch succes — niet alleen wat een hengsthouder pusht.",
        },
        {
          icon: "Share2",
          title: "Samenwerking dierenarts/inseminator",
          body: "Echo's, monsters en statussen direct gedeeld met de praktijk die werkt aan jouw merries.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs andere fokkerij software.",
      lead: "De Nederlandse SERP voor fokkerij software toont vaak generieke paardenapps die fokkerij in één zin noemen. We vergelijken eerlijk welke tools écht een complete fokkerijflow hebben.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Gratis starten",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Merriecyclus loggen",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inseminatiedatum + hengst",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Echo's & drachtcontrole",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Verwachte veulendatum",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Veulen dossier (gewicht/groei)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Stamboom tot 4-5 generaties",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & paspoortregistratie",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Hengstkeuze / matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryotransplantatie",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Multi-merrie overzicht",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobiel (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Delen met dierenarts",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Geïntegreerd met algemeen dossier",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Verkoop & marketing van veulens",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Vergelijking op basis van publiek beschikbare features in januari 2026. EquineGenie is sterk in fokkerij, maar minder in mobiel + algemeen paardenbeheer. EquiSight combineert beide.",
    },
    why: {
      title: "Waarom EquiSight fokkers anders bedient.",
      lead: "Veel fokkers werken met losse fokkerij software én een aparte paardenmanagement app. EquiSight combineert beide — zonder dat je tussen apps switcht of data dubbel invoert.",
      points: [
        {
          icon: "Heart",
          title: "Fokmerrie blijft ook gewoon paard",
          body: "De fokmerrie heeft een fokjaar én een gewoon paardendossier — gezondheid, vaccinaties, hoefsmid. Eén app, alle modules.",
        },
        {
          icon: "Sparkles",
          title: "Voorspellend ipv reactief",
          body: "Cyclusvoorspelling, drachtmijlpaal-herinneringen en veulenkalender — automatisch op basis van jouw data.",
        },
        {
          icon: "Share2",
          title: "Iedereen rondom de fokkerij",
          body: "Inseminator, hengstenhouder, dierenarts, koper, stamboek — allemaal toegang met de juiste rechten.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per discipline · cyclus tot afspenen",
      title: "Wat een fokkerijdossier in EquiSight bevat.",
      lead: "Per merrie krijg je een compleet fokdossier, gekoppeld aan haar reguliere paarddossier.",
      items: [
        "Dagelijkse cyclus log met voorspelling",
        "Inseminatie/dekking + hengstgegevens",
        "Echo timeline (14/21/60 dagen + geslacht)",
        "Drachtmijlpalen met automatische reminders",
        "Verwachte veulendatum en voorbereiding",
        "Veulen dossier vanaf geboorte",
        "Stamboom tot opa/oma met klik-navigatie",
        "DNA-monster, paspoort, stamboekstatus",
        "Verkoop pipeline met geïnteresseerden",
        "Hengstkeuze geschiedenis per merrie",
      ],
      ctaLabel: "Bekijk de fokkerijmodule",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Voor de hele stoeterij",
      title: "Overzicht voor meerdere merries en hengsten.",
      lead: "Wanneer je meer dan 2-3 merries fokt, wordt overzicht over alle cycli en drachten cruciaal.",
      cards: [
        {
          t: "Cyclus dashboard",
          d: "Alle merries naast elkaar, met cyclusstadium en volgende actie.",
        },
        {
          t: "Dracht pipeline",
          d: "Welke merries zijn waar in de drachtmijlpalen?",
        },
        {
          t: "Veulenkalender",
          d: "Verwachte geboortes per maand, met logistiek erop afgestemd.",
        },
        {
          t: "Hengst portfolio",
          d: "Eigen hengsten of vaste inseminatoren met bestelhistorie.",
        },
        {
          t: "Stamboomgrafiek",
          d: "Voorouder analyse over meerdere generaties en lijnen.",
        },
        {
          t: "Verkoop dashboard",
          d: "Welke veulens zijn verkocht, gereserveerd of nog beschikbaar.",
        },
      ],
    },
    beforeAfter: {
      title: "Van Excel + agenda naar EquiSight fokkerij.",
      lead: "Concreet: zo verandert je fokseizoen.",
      rows: [
        {
          before: "Cyclus in losse notitie",
          after: "Dagelijkse log met voorspelling",
        },
        {
          before: "Echo's via WhatsApp aan inseminator",
          after: "Gedeeld dossier met fotos",
        },
        {
          before: "Drachtdatum in agenda",
          after: "Automatische mijlpaal reminders",
        },
        {
          before: "Veulenpaspoort in la",
          after: "Document gekoppeld aan veulen profiel",
        },
        {
          before: "Stamboom op papier",
          after: "Klikbare stamboom tot 4-5 generaties",
        },
        {
          before: "Verkoopadvertentie op Marktplaats",
          after: "Verkoop pipeline met interesselijst",
        },
      ],
    },
    helper: {
      title: "Welke fokkerij software past bij jou?",
      lead: "5 vragen om te kijken of je een complete fokkerij app nodig hebt of een hobby-tool volstaat.",
      questions: [
        {
          id: "mares",
          q: "Hoeveel fokmerries beheer je?",
          options: [
            {
              label: "1 merrie",
              score: 1,
            },
            {
              label: "2-5 merries",
              score: 2,
            },
            {
              label: "Meer dan 5 merries",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Hoe vaak fok je per jaar?",
          options: [
            {
              label: "Incidenteel (om de paar jaar)",
              score: 0,
            },
            {
              label: "Elk jaar 1-2 dekkingen",
              score: 2,
            },
            {
              label: "Elk jaar 3+ dekkingen",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Hoe insemineer/dek je?",
          options: [
            {
              label: "Natuurlijke dekking",
              score: 1,
            },
            {
              label: "KI vers/gekoeld sperma",
              score: 2,
            },
            {
              label: "ET of diepvries",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Werk je samen met dierenarts/inseminator?",
          options: [
            {
              label: "Eén vaste persoon",
              score: 1,
            },
            {
              label: "Meerdere praktijken",
              score: 2,
            },
            {
              label: "Internationaal netwerk",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Wat houd je nu bij?",
          options: [
            {
              label: "Excel of papier",
              score: 1,
            },
            {
              label: "Algemene paardenbeheer app",
              score: 2,
            },
            {
              label: "Niets gestructureerd",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Een hobby-tool of Excel volstaat — maar EquiSight blijft handig.",
          body: "Voor 1 merrie met natuurlijke dekking om de paar jaar is een uitgebreide fokkerijmodule overkill. EquiSight start gratis en activeer je de fokkerijmodule alleen voor het jaar dat je dekt — zonder upgrade verplichting.",
          cta: "Start gratis",
        },
        mid: {
          title: "EquiSight fokkerij is de juiste tool.",
          body: "Je hebt meerdere merries of meerdere fokmethodes — daar zijn algemene paardenapps niet op gebouwd. EquiSight combineert fokkerij + algemene zorg, zodat je niet tussen twee tools schakelt.",
          cta: "Bekijk de fokkerijmodule",
        },
        high: {
          title: "EquiSight is gebouwd voor jouw stoeterij.",
          body: "Meerdere merries, ET of diepvries, internationaal team — de meeste tools komen hier tekort. EquiSight schaalt mee tot stoeterij-niveau zonder dat je extra licenties stapelt.",
          cta: "Praat met ons over een Stoeterij plan",
        },
      },
    },
    faqTitle: "Veelgestelde vragen over fokkerij software",
    faq: [
      {
        q: "Wat is de beste fokkerij software voor paarden?",
        a: "Voor 1 merrie zonder ingewikkelde fokmethode volstaan veel tools. Vanaf 2-3 merries, gebruik van KI of ET, of samenwerking met dierenarts en stamboek wordt een complete fokkerijmodule cruciaal. EquiSight combineert fokkerij met algemeen paardenbeheer in één app, waardoor je niet hoeft te switchen.",
      },
      {
        q: "Welke fokkerij functies heb ik écht nodig?",
        a: "Minimaal: cyclus log, inseminatie/dekking gegevens, drachtcontrole-mijlpalen, en veulen dossier. Optioneel maar krachtig: stamboomweergave, hengstkeuze archief, DNA/paspoort en verkoop pipeline.",
      },
      {
        q: "Kan EquiSight een merrie's cyclus voorspellen?",
        a: "Ja. EquiSight gebruikt eerdere cyclus-data om de voorspelde ovulatie te tonen, zodat je inseminatie of dekking op het juiste moment plant — zonder dagelijks puzzelen.",
      },
      {
        q: "Werkt EquiSight ook voor embryotransplantatie?",
        a: "Ja. Donor- en ontvangermerrie krijgen gekoppelde dossiers, ET-kalender en gedeelde mijlpalen met de praktijk. Zo verlies je geen tijdlijn in de complexe ET-flow.",
      },
      {
        q: "Kan ik mijn bestaande fokdata importeren?",
        a: "Je kunt cyclus, dekkingen en veulendata handmatig invoeren of in batch via CSV. Bij actieve fokkerijen helpen we met een eenmalige migratie als je over meerdere seizoenen data hebt staan.",
      },
      {
        q: "Hoe deel ik dossier met mijn dierenarts of inseminator?",
        a: "Per persoon krijg je toegang met een rol: dierenarts, inseminator, hengstenhouder of stamboek-functionaris. Iedereen ziet alleen de informatie die nodig is voor zijn rol — geen volledige toegang nodig.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Gidsen & keuzehulpen voor paardenbeheer software | EquiSight",
      description: "Alle EquiSight gidsen op één plek: paardenbeheer, fokkerij, manege en trainer software vergelijkingen plus keuzehulpen voor 2026.",
      keywords: [
        "paardensoftware gidsen",
        "paardenbeheer keuzehulp",
        "fokkerij software vergelijken",
        "manege software gids",
        "trainer app vergelijking",
      ],
    },
    hub: {
      eyebrow: "Hub · gidsen",
      breadcrumbLabel: "Gidsen",
      title: "Vier complete gidsen om de juiste paardensoftware te kiezen.",
      intro: "Voor iedere doelgroep een diepgaande keuzehulp: vergelijkingstabellen, criteria, voorbeelden en interactieve quiz. Klik door naar de gids die past bij jouw situatie, of verken eerst de verdiepende artikelen onder elke cluster.",
      stats: {
        guides: "4 keuzehulpen",
        articles: "15 verdiepende artikelen",
        fair: "Eerlijke vergelijking",
      },
      readMoreCta: "Lees de complete gids",
      relatedHeading: "Verdiepende artikelen",
      articlesCountSingular: "{{count}} verdiepend artikel",
      articlesCountPlural: "{{count}} verdiepende artikelen",
      articlesCountAria: "Aantal cluster-artikelen",
      lastUpdatedPrefix: "Bijgewerkt",
      lastUpdatedAria: "Datum laatste update van deze cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Paardenbeheer app keuzehulp",
        blurb: "Vergelijk de bekendste paardenbeheer apps en ontdek welke past bij eigenaar, stal of fokkerij. Inclusief eerlijke vergelijkingstabel en 5-vragen keuzehulp.",
        audience: "Voor eigenaren, stalhouders en alle paardenmensen die overzicht zoeken.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Fokkerij software vergelijking",
        blurb: "Van merriecyclus tot veulenontwikkeling: bekijk welke fokkerij software echt werkt voor jouw aantal merries, fokmethode en stamboek-eisen.",
        audience: "Voor (hobby)fokkers, stoeterijen en hengstenhouders.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Manege software keuzehulp",
        blurb: "Lesplanning, ruiteradministratie, eigenaarsportaal en facturatie — in één tool. Vergelijk de opties voor maneges en pensionstallen in 2026.",
        audience: "Voor maneges, pensionstallen en rij-bedrijven.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trainer app keuzehulp",
        blurb: "Coaching-CRM, video-feedback, KNHS-protocol scannen en doelen per combinatie. Welke trainer app past bij jouw coaching praktijk?",
        audience: "Voor instructeurs, trainers en coaches.",
      },
    ],
    closing: {
      eyebrow: "Waarom deze gidsen",
      title: "Eerlijk vergelijken, niet alleen prijzen.",
      body1: "Veel \"vergelijkingspagina's\" zijn verkapte advertenties. Onze gidsen zetten functies, doelgroep en concurrenten naast elkaar zoals een onafhankelijke kennisbron dat zou doen. EquiSight komt natuurlijk naar voren als complete oplossing, maar je leest ook eerlijk waar andere apps sterker zijn.",
      body2: "De verdiepende artikelen onder elke gids beantwoorden de concrete vragen die voortkomen uit de keuze: \"Wanneer eerste echo na inseminatie\", \"Hoe automatiseer ik manege facturatie\", \"Hoe analyseer ik een wedstrijdprotocol\". Geen marketingfluff, wel praktijk.",
    },
    hubName: "EquiSight Gidsen",
  },
};

export default CORNERSTONES;
